import { ReactNode, useEffect, useState } from "react";

/**
 * Component that renders only on the client and not during SSR.
 */
interface ClientOnlyProps {
  children?: ReactNode;
}

export function ClientOnly({ children }: ClientOnlyProps): JSX.Element | null {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return <>{children}</>;
}
